import { TouchableOpacity, Platform } from "react-native";
import React from "react";
import {
  View,
  Text,
  Heading,
  Button,
  Icon,
  IconButton,
  HStack,
  Pressable,
} from "native-base";
import { MaterialCommunityIcons } from "@expo/vector-icons";

type HeaderProps = {
  onPress: () => void;
  headingText?: string;
  parentText?: string;
  intro?: string;
};
const Header = (props: HeaderProps) => {
  const { onPress, headingText, parentText, intro } = props;
  return (
    <View
      mb={2}
      mt={Platform.OS == "web" ? "20" : "5"}
      px={5}
      justifyContent="center"
    >
      {headingText && (
        <Pressable
          alignItems={"center"}
          justifyContent={"center"}
          position={"relative"}
          flexDirection={"row"}
          onPress={onPress}
          py={5}
        >
          {/* {parentText && (
            <View position={"absolute"} left={20}>
              
              <MaterialCommunityIcons name="arrow-left" color={"#fff"} />
            </View>
          )} */}

          <Text textAlign="center" fontFamily="Montserrat">
            <Text>{parentText && "←"}</Text> {parentText}
          </Text>
        </Pressable>
      )}

      <Pressable
        // alignItems={"center"}
        mb={5}
        mt={10}
        // justifyContent={!parentText ? "flex-start" : "center"}
        alignItems={"center"}
        justifyContent={"center"}
        flexDirection={"row"}
        onPress={onPress}
        position={"relative"}
        py={3}
      >
        {/* {!parentText && (
          <View position={"absolute"} left={0}>
            <MaterialCommunityIcons
              name="arrow-left"
              size={22}
              color={"#fff"}
            />
          </View>
        )} */}

        <Heading textAlign="center" textTransform={"capitalize"}>
          <Text style={{ marginRight: 10 }}>
            {headingText && !parentText && "←"}
          </Text>
          {headingText}
        </Heading>
      </Pressable>

      <Text
        textAlign="center"
        mb={5}
        fontFamily="Avenir-Bold"
        w="3/4"
        alignSelf={"center"}
      >
        {intro}
      </Text>
    </View>
  );
};

export default Header;
